module.exports = "<div class = \"renderer-wrapper\">\r\n      <span class=\"renderer-default\">\r\n            <a class=\"hyperlink-content\" (click)=\"downloadFile(params.node.data['fileName'].cVal);\"> {{ params.node.data['fileName'].cVal }} </a>\r\n      </span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/inventory/work-order-management/work-order-execution/work-orders/aggrid-custom-cell/filename-cell-renderer.component.html
// module id = ../../../../../src/app/features/inventory/work-order-management/work-order-execution/work-orders/aggrid-custom-cell/filename-cell-renderer.component.html
// module chunks = main